import { FC } from 'react';
import classNames from 'classnames';

type ProgressBarProps = {
  progress: number; // Progress percentage (0-100)
  showLabel?: boolean;
  barClassName?: string; // Additional className for the progress bar container
};

export const ProgressBar: FC<ProgressBarProps> = ({ progress, showLabel = true, barClassName }) => {
  const clampedProgress = Math.max(0, Math.min(100, progress));
  const isComplete = clampedProgress === 100;
  const progressColor = isComplete ? 'bg-teal-500' : 'bg-orange-400';

  return (
    <div className="flex w-full items-center space-x-3">
      <div
        className={classNames('flex-1 overflow-hidden rounded-full bg-gray-200', barClassName)}
        role="progressbar"
        data-testid="progress-bar"
        aria-valuenow={clampedProgress}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Progress: ${clampedProgress}%`}
      >
        <div
          className={`h-2 rounded-full transition-all duration-300 ease-out ${progressColor}`}
          data-testid="progress-bar-fill"
          style={{ width: `${clampedProgress}%` }}
        />
      </div>

      {
        // We use a fixed width for the percentage text to ensure alignment
        // 4 characters wide because 100% has 4 characters and is the maximum value
      }
      {showLabel ? <span className="w-[4ch] text-right">{clampedProgress}%</span> : null}
    </div>
  );
};
